<template>
    <div id="app">
        <div class="landscape-only-banner">
            <div class="logo"></div>
            <span>{{$t('please-rotate-device')}}</span>
            <img src="./assets/images/rotate-device.gif" />
        </div>
        <transition name="fade-views">
            <router-view />
        </transition>
    </div>
</template>

<style lang="scss">
    @import "./assets/scss/variables.scss";
    @import "./assets/scss/main.scss";
</style>

<script>

export default {

    data: function() {
        return {

        }
    },

    mounted () {

    },

    methods: {

    }
}
</script>